import { Component } from "react";
import { Tooltip } from "./Tooltip";

import "./InfoIconTooltip.scss";

export default class InfoIconTooltip extends Component {
  render() {
    if (!this.props.text && !this.props.children) {
      return <span />;
    }

    let content = this.props.children ? this.props.children : this.props.text;

    return (
      <Tooltip content={content} className={this.props.className}>
        <span className="infoIcon">i</span>
      </Tooltip>
    );
  }
}
